import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor() { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                // catchError(this.parseErrorBlob),
                catchError((err) => {
                    console.error('Error from GLOBAL error HTTP interceptor');
                    if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.error.type === 'application/json') {
                        // https://github.com/angular/angular/issues/19888
                        // When request of type Blob, the error is also in Blob instead of object of the json data
                        return new Promise<any>((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onload = (e: Event) => {
                                try {
                                    const errmsg = JSON.parse((<any>e.target).result);
                                    reject(new HttpErrorResponse({
                                        error: errmsg,
                                        headers: err.headers,
                                        status: err.status,
                                        statusText: err.statusText,
                                        url: err.url || undefined
                                    }));
                                } catch (e) {
                                    reject(err);
                                }
                            };
                            reader.onerror = (e) => {
                                reject(err);
                            };
                            reader.readAsText(err.error);
                        });
                    }
                    throw err;
                    // return throwError(err);
                }),
                finalize(() => {
                })
            ) as Observable<HttpEvent<any>>;
    }

    parseErrorBlob(err: HttpErrorResponse): Observable<any> {
        const reader: FileReader = new FileReader();
        const obs = Observable.create((observer: any) => {
            reader.onloadend = (e) => {
                const temp = reader.result;
                observer.error(JSON.parse(temp as string));
                observer.complete();
            };
        });
        reader.readAsText(err.error);
        return obs;
    }

}
